<template>
  <v-list-group @click="toggleSubcategory" :ref="subcategory.permalink">
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-title>
          <a v-bind:href="'?categories=' + subcategory.permalink" @click.prevent>
            {{ subcategory.name }}
          </a>
        </v-list-item-title>
      </v-list-item-content>
    </template>

    <v-list-item-group class="pl-5" v-if="subcategoryChildren.length > 0">
      <sub-subcategories
        v-for="child in subcategoryChildren"
        :key="child.id"
        :params="params"
        :subSubcategory="child"
        :layout="layout"
        @all-deactivated="updateUrl(subcategory)"
      ></sub-subcategories>
    </v-list-item-group>
  </v-list-group>
</template>

<script>
  import SubSubcategories from './SubSubcategories';

  export default {
    props: ['subcategory', 'params', 'categories', 'categoriesFromUrl', 'layout'],
    components: { SubSubcategories },
    data() {
      return {
        lastCategory: {},
      };
    },
    mounted() {
      this.setCategoriesFromUrl();
    },
    computed: {
      subcategoryChildren() {
        return this.categories.filter(category => category.parent_id === this.subcategory.id) || [];
      },
    },
    methods: {
      toggleSubcategory() {
        if (this.$refs[this.subcategory.permalink].$children[1] !== undefined) {
          this.deactivateChildren(this.subcategory);
        }

        this.lastCategory = this.subcategory;

        const baseSubcategory = this.params.categories.filter(baseSubcategory => {
          return baseSubcategory.depth === 1 && this.subcategory === baseSubcategory;
        });

        this.$delete(this.params.categories, 2);
        this.$delete(this.params.categories, 1);

        if (!baseSubcategory.length > 0) {
          this.params.categories.push(this.subcategory);
        } else {
          setTimeout(() => {
            this.$emit('all-deactivated');
          }, 100)
        }
        this.updateUrl(this.subcategory);
      },

      updateUrl(category) {
        const url = new URL(location.href);
        url.searchParams.set('categories', category.permalink);
        history.pushState(null, '', url.toString().replace('%2F', '/'));
      },

      deactivateChildren(category) {
        this.$refs[category.permalink].$children[1].$children.forEach(child => child.$children[0].isActive = false);
      },
      setCategoriesFromUrl() {
        if (this.layout.categoriesFromUrl[1]) {
          if (this.subcategory.permalink.split('/')[1].toLowerCase() === this.layout.categoriesFromUrl[1].toLowerCase()) {
            this.toggleSubcategory(this.subcategory);
            this.$refs[this.subcategory.permalink].isActive = true;
          }

          if (this.layout.categoriesFromUrl.length === 2) {
            this.params.setCategoriesFromUrl = true
          }
        }
      },
    },

    watch: {
      'params.categories': function() {
        if (this.params.categories[1]) {
          if (this.params.categories[1].depth !== 1) {
            this.$delete(this.params.categories, 1);
          }
        }

        if (!this.params.categories[1]) {
          setTimeout(() => {
            this.$refs[this.subcategory.permalink].isActive = false;
          }, 100);
        }
      },
    },
  };
</script>